<button [disabled]="loading || disabled" class ="btn btn-primary m-1">
    <span *ngIf="loading" class="spinner-border spinner-border-sm my-1" role="status" aria-hidden="true"></span>
    {{ text }}
</button>
